// src/service/paymentTerms/PaymentTermsService.ts
import { get, post } from "../../utils/BaseService";

export interface PaymentTerm {
  payment_term_id: number;
  name: string;
  value: number;
}

export async function getAllPaymentTerms(dispatch: any): Promise<PaymentTerm[]> {
  return await get(dispatch, '/paymentTerms/getAll', null);
}

export async function getPaymentTermById(dispatch: any, id: number): Promise<PaymentTerm | null> {
  return await get(dispatch, `/paymentTerms/getById/${id}`, null);
}